import type { Language } from "@marshmallow-duel/simulation";

const czech: Readonly<Record<string, string>> = {
  rm_arena_2_0: "Původní",
  rm_arena_2_1: "Ta nejlepší",
  rm_arena_2_2: "Mapa beze jména",
  rm_arena_2_3: "Pyramida z bloků",
  rm_arena_2_4: "Xko",
  rm_arena_2_5: "Vzdušné ostrovy",
  rm_arena_2_6: "Kopači",
  rm_arena_2_7: "Pavoučí země",
  rm_arena_2_8: "Teleportační boxy",
  rm_arena_2_9: "Šplhání",
  rm_arena_2_10: "Poseidonův sloup",
  rm_arena_2_11: "Turbína",
  rm_arena_3_0: "Xko",
  rm_arena_3_1: "Turbína",
  rm_arena_4_0: "Xko",
  rm_arena_4_1: "Turbína"
};

export const localizedMapName = (language: Language, id: string, fallback: string): string => language === "cz" ? czech[id] ?? fallback : fallback;
